import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defaultFlowsLogo } from '../setting/form/enum';
import { getFlowTypes } from 'api/flow';
var dataInit = function dataInit() {
  return {
    cn: '',
    th: '',
    en: ''
  };
};
export default {
  props: {
    lang: {
      type: String
    }
  },
  data: function data() {
    return {
      visible: false,
      form: dataInit(),
      defaultFlowsLogo: []
    };
  },
  methods: {
    init: function init() {
      var _this = this;
      this.visible = true;
      this.form = dataInit();
      // 获取审批流类型
      getFlowTypes().then(function (res) {
        _this.defaultFlowsLogo = [defaultFlowsLogo].concat(_toConsumableArray(res.data));
      });
    },
    handlerCreate: function handlerCreate(item) {
      if (this.lang === 'id' && item.type === 2) return;
      this.$router.push({
        path: '/approval/addSetting',
        query: {
          type: 'add',
          params: JSON.stringify(item)
        }
      });
    }
  }
};